<template>
  <div v-if="!hasPermission('Store Terminal')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <form @submit.prevent="releaseTerminal" class="p-4">

      <div class="mb-3">
        <label for="terminalName" class="form-label mb-3">Nome do Terminal</label>
        <input
            id="terminalName"
            v-model="terminalName"
            type="text"
            class="form-control"
            required
            placeholder="Digite o nome do terminal"
        />
      </div>

      <div class="mb-5">
        <label class="form-label mb-3">Tipo do Terminal</label>
        <div>
          <div
              v-for="type in terminalTypes"
              :key="type.value"
              class="form-check form-check-inline  ms-2"
          >
            <input
                class="form-check-input"
                type="radio"
                :id="`type-${type.value}`"
                :value="type.value"
                v-model="terminalType"
                required
            />
            <label class="form-check-label" :for="`type-${type.value}`">
              {{ type.label }}
            </label>
          </div>
        </div>
      </div>

      <button type="submit" class="btn btn-primary px-5 py-3">Registrar Terminal</button>

    </form>
  </div>
</template>
<script>
import http from '@/helpers/http';
import alert from '@/helpers/alert';
import Permission from '../../helpers/permission';

export default {
  name: 'RegisterExternalTerminal',
  data() {
    return {
      terminalName: '',
      terminalType: '',
      tempHash: this.$route.query.temp_hash || '',
      terminalTypes: [
        { value: 'KI', label: 'Totem' },
        { value: 'SC', label: 'Telão' },
      ]
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    releaseTerminal() {
      http.post(`places/${this.place.id_place}/terminals/release`, {
        temp_hash: this.tempHash,
        terminal_name: this.terminalName,
        terminal_type: this.terminalType
      }).then(response => {
        alert.success('Terminal liberado com sucesso!');
        this.$router.push('/dashboard');
      }).catch(error => {
        alert.toastError(error.response.data.message || 'Erro ao liberar terminal. Tente novamente.');
      });
    }
  }
}
</script>

<style scoped>

</style>